const stableJson = (value)=>{
    if (Array.isArray(value)) return value.map(stableJson);
    if (value === null || typeof value !== 'object') return value;
    return Object.keys(value).sort().map((key)=>[
            key,
            stableJson(value[key])
        ]);
};
// WHY no names: both lanes derive them from the rows currently LISTED, so a search hiding a checked row would move this key.
export const greetingScopeKey = (parts)=>{
    var _parts_selectedIds;
    const selectedIds = [
        ...(_parts_selectedIds = parts.selectedIds) !== null && _parts_selectedIds !== void 0 ? _parts_selectedIds : []
    ].sort();
    const isCountedByFilter = selectedIds.length === 0 && parts.currentFilter != null;
    return JSON.stringify([
        selectedIds,
        isCountedByFilter ? parts.matchedCount : 0,
        stableJson(parts.currentFilter)
    ]);
};
